<template>
  <b-card
      :title="this.getHeadline"
      footer-tag="footer"
  >
    <b-card-text>
      Status: {{deal.Deal_Phase}}<br>
      Betrag: {{this.getBetrag}}<br>
    </b-card-text>
    <template #footer>{{deal.Pipeline}}<br><em>Letzte Änderung: {{datum}}</em></template>
  </b-card>
</template>

<script>
import moment from 'moment'
export default {
  name: 'DealComponent',
  data () {
    return {
      datum: null
    }
  },
  props: ['deal'],
  beforeMount () {
    moment.locale('de')
    this.datum = moment(String(this.deal.Erstellungsdatum)).format('DD.MM.YYYY')
  },
  computed: {
    getBetrag () {
      if (this.deal.Betrag !== null && this.deal.Betrag !== 0) {
        return this.deal.Betrag
      }
      return 'Offen'
    },
    getHeadline () {
      if (this.deal.Associated_Company !== null && this.deal.Associated_Company !== '') {
        return this.deal.Associated_Company
      }
      return this.deal.Deal_Name
    }
  }
}
</script>

<style scoped>

</style>
